import { isSaleActive } from "../utils/salePricing";

export default function PriceWithSale({
  price,
  salePrice,
  saleStartAt,
  saleEndAt,
  tierPrice = null,
  showTierTag = false,
  forceBasePrice = false,
}) {
  const basePrice = Number(price ?? 0);
  const normalizedTierPrice =
    tierPrice !== null && tierPrice !== undefined
      ? Number(tierPrice)
      : null;

  if (Number.isFinite(normalizedTierPrice)) {
    return (
      <div>
        <div>
          <span className="text-primary fw-bold me-2">
            ${normalizedTierPrice.toFixed(2)}
          </span>
          <span className="text-muted text-decoration-line-through">
            ${basePrice.toFixed(2)}
          </span>
        </div>
        {showTierTag && (
          <small className="badge bg-info mt-1">
            Wholesale Price
          </small>
        )}
      </div>
    );
  }

  if (forceBasePrice) {
    return <span>${basePrice.toFixed(2)}</span>;
  }

  const onSale = isSaleActive({
    price: basePrice,
    salePrice,
    saleStartAt,
    saleEndAt,
  });

  if (!onSale) {
    return <span>${basePrice.toFixed(2)}</span>;
  }

  const percentOff = Math.round(((basePrice - salePrice) / basePrice) * 100);

  return (
    <div>
      <div>
        <span className="text-danger fw-bold me-2">
          ${Number(salePrice).toFixed(2)}
        </span>
        <span className="text-muted text-decoration-line-through">
          ${basePrice.toFixed(2)}
        </span>
      </div>
      <small className="badge bg-success mt-1">{percentOff}% OFF</small>
    </div>
  );
}
